import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export const setCurrentContextKeyAction = (state: ImageHandlingState, action: PayloadAction<string | null>) => {
	state.currentContextKey = action.payload;
};
